// Stub pour react-native-blob-util sur le web
const RNBlobUtil = {
  fs: {
    dirs: {
      DocumentDir: '',
      CacheDir: '',
      DownloadDir: '',
    },
    writeFile: () => Promise.resolve(),
    readFile: () => Promise.resolve(''),
    exists: () => Promise.resolve(false),
    unlink: () => Promise.resolve(),
  },
  config: () => ({
    fetch: () => Promise.resolve({ path: () => '' }),
  }),
  ios: {
    openDocument: () => Promise.resolve(),
    previewDocument: () => Promise.resolve(),
  },
  android: {
    actionViewIntent: () => Promise.resolve(),
  },
};

export default RNBlobUtil;
module.exports = RNBlobUtil;
